<template>
    <div class="chosedialog ">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog shoudafangdialag" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" @submit.native.prevent class="demo-form-inline h-formBorder" style="margin-left:-1.84rem">
                                <el-form-item label="用户账号/名称"  style="width: 80%;">
                                    <el-input clearable v-model="q.usercodename"></el-input>
                                </el-form-item>
                                <el-form-item style="margin-top:-20px">
                                    <el-button type="primary"  icon="el-icon-search" @click="handleFilter" >搜索</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
                                :data="ttdata"
								:border="true"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    prop="usercode"
                                    label="账号"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="username"
                                    label="名称"
                                    width="150"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="usertype"
                                    width="110"
                                    label="账户类型"
									:show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    {{scope.row.usertype|dictname('yonghu_leixing')}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="areaname"
                                    label="区域"
                                    width="150"
									:show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    width="100"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="phone"
                                    label="电话"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="email"
                                    width="170"
                                    label="邮箱"
									:show-overflow-tooltip="true">
                            </el-table-column>

                        </el-table>
                        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                            <paginationmin :page="q" @query="queryUser"/>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        name: "alluser",
        data(){
          return {

              q:{
                  pageSize:10,
                  pageNo:1,
                  total:0,

                  usercodename:null,
              },
              ttdata:null,
              users:[]
          }
        },
        computed: {
            Ddlx:function () {
                return this.ddlx
            },
            nxWX:function () {
                return this.nxWX
            },
            XmCode:function () {
                return this.xmcode
            },
            UserCode:function () {
                return this.usercode
            },
            AreaCode:function () {
                return this.areacode
            },
            Xszz:function () {
                return this.xszz
            }
        },
        methods: {
            handleFilter(){
                this.queryUser();
            },
            queryUser(p){
                this.q.xmcode = this.XmCode;
                this.q.usercode = this.UserCode;
                this.q.ddlx = this.ddlx;
                this.q.nxWx = this.nxWx;
                this.q.areacode = this.AreaCode;
                this.q.xszz = this.Xszz;
                ss.selectUserAgent.cesuanselectUserAgentPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.ttdata = rd.records;
                })
            },
            handleSelectionChange(users){
                if(this.oneflag){
                    this.$emit('choseObj', users[0])
                }else{
                    this.$emit('choseObj', users)
                }

            },
        },
        created(){
            this.queryUser()
        },
        props: {
            dialogVisible: {
                type: Boolean,
            },
            areacode:{
                type:String,
            },
            usercode:{
                type:String,
            },
            //项目编码
            xmcode:{
                type:String,
            },
            //订单类型
            ddlx:{
                type:String,
            },
            xszz:{
                type:String,
            },
            oneflag:{
                type:Boolean,
            },
            //1内销 2外销
            nxWx:{
                type:String,
            },
        }
    }
</script>

<style>
    .shoudafangdialag .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .shoudafangdialag .el-dialog__body{
        padding: 20px;
    }
    .shoudafangdialag .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .shoudafangdialag .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .shoudafangdialag  .h-formbLine .el-form-item__content{
        width: 55%;
    }
    .shoudafangdialag .yxline .h-formbLine .el-form-item__content{
		 width: 55%;
	}
    .shoudafangdialag .yxline{
		padding-top: 0;
	}
    .shoudafangdialag .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .shoudafangdialag .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
